export enum ImConferenceModeEnum {
  Host = 1,
  Discussion = 2,
}

export interface ImConferenceDto {
  id: string;
  mode: ImConferenceModeEnum;
  createTime?: number;
}
